import {instance as request} from '@/utils/request.js'
export function  batchAudit(params) {
  return request({
    url:'merchandise/batchAudit',
    method:'post',
    data:params
  })
}
export function  getMdseDetails(params) {
  return request({
    url:'merchandise/getMdseDetails',
    method:'get',
    params:params
  })
}

// /merchandise/getLicDistributors
// 功能说明--查询某个商品授权过的全部渠道商，授权栏右
export function  getLicDistributors(params) {
  return request({
    url:'/merchandise/getLicDistributors',
    method:'get',
    params:params
  })
}